import React, { useState, useEffect } from 'react';

import { LoaderSpinner } from '@vw-marketing/us-components';

import { createLaunchDarklyProvider } from '../../services/launch-darkly-service';

interface LaunchDarklyProviderProps {
  children: React.ReactNode;
  clientId: string; // LaunchDarkly client ID
  countryCode: string; // Country code from locale-service
}

type ProviderComponent = React.FC<{ children: React.ReactNode }>;

export const LaunchDarklyProvider: React.FC<LaunchDarklyProviderProps> = ({
  clientId,
  countryCode = '',
  children,
}) => {
  const [LDProvider, setLDProvider] = useState<null | ProviderComponent>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initLaunchDarkly = async () => {
      try {
        if (!clientId) return;

        setLoading(true);

        const Provider = await createLaunchDarklyProvider(clientId, countryCode);

        setLDProvider(() => Provider);
      } catch (error) {
        console.error('Failed to initialize LaunchDarkly:', error);
        // Provide a fallback that just renders the app without LaunchDarkly
        setLDProvider(() => ({ children }) => <>{children}</>);
      } finally {
        setLoading(false);
      }
    };

    initLaunchDarkly();
  }, [clientId]);

  if (loading) {
    return <LoaderSpinner />;
  }

  return LDProvider ? <LDProvider>{children}</LDProvider> : <>{children}</>;
};
